import { useCallback, useEffect, useRef, useState } from "react";

export const RESEND_COOLDOWN_SECONDS = 60;

export function useResendCooldown(seconds: number = RESEND_COOLDOWN_SECONDS) {
  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const clear = useCallback(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const startCooldown = useCallback(() => {
    const deadline = Date.now() + seconds * 1000;
    const tick = () => {
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      setSecondsRemaining(remaining);
      if (remaining === 0) clear();
    };
    clear(); // re-entry guard: never stack intervals
    tick(); // paint the full duration immediately, before the first interval fires
    intervalRef.current = setInterval(tick, 1000);
  }, [seconds, clear]);

  useEffect(() => clear, [clear]); // clear on unmount

  return { isDisabled: secondsRemaining > 0, secondsRemaining, startCooldown };
}
